import { createTheme, ThemeOptions } from "@mui/material/styles";

const baseTheme: ThemeOptions = {
  typography: {
    fontFamily: "'Inter', 'Roboto', 'Helvetica', 'Arial', sans-serif",
    h1: {
      fontWeight: 700,
      letterSpacing: "-0.02em",
    },
    h2: {
      fontWeight: 600,
      letterSpacing: "-0.01em",
    },
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: ({ theme }) => ({
          borderRadius: 8,
          textTransform: "none",
          fontWeight: 500,
        }),
      },
    },
  },
};

export const lightTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "light",
    primary: {
      main: "rgb(1, 2, 11)",
    },
    secondary: {
      main: "rgb(3, 173, 246)",
    },
    background: {
      default: "rgb(250, 250, 250)",
      paper: "rgb(255, 255, 255)",
    },
  },
});

export const darkTheme = createTheme({
  ...baseTheme,
  palette: {
    mode: "dark",
    primary: {
      main: "rgb(255, 255, 255)", // Inverted from light theme for better contrast
    },
    secondary: {
      main: "rgb(3, 173, 246)", // Keeping the same accent color
    },
    background: {
      default: "rgb(18, 18, 18)", // Dark mode background
      paper: "rgb(30, 30, 30)", // Slightly lighter than background for cards
    },
    text: {
      primary: "rgb(255, 255, 255)",
      secondary: "rgba(255, 255, 255, 0.7)",
    },
  },
});

export { lightTheme as theme }; // For backward compatibility
